/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Cancelled_TitleInputs */

const en_mcp_connect_cancelled_title = /** @type {(inputs: Mcp_Connect_Cancelled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection cancelled`)
};

const es_mcp_connect_cancelled_title = /** @type {(inputs: Mcp_Connect_Cancelled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexión cancelada`)
};

/**
* | output |
* | --- |
* | "Connection cancelled" |
*
* @param {Mcp_Connect_Cancelled_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_cancelled_title = /** @type {((inputs?: Mcp_Connect_Cancelled_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Cancelled_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_cancelled_title(inputs)
	return en_mcp_connect_cancelled_title(inputs)
});